import React from "react";

export default function SQLServer_ATN2() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ATN2</h1>
      <p>This is the SQLServer_ATN2 component generated from the SQL JSON.</p>
    </div>
  );
}
